(function (root) {
  'use strict';

  function clampInt(n, min, max) {
    var v = parseInt(n, 10);
    if (!isFinite(v)) v = 0;
    v = Math.max(min, v);
    if (typeof max === 'number') v = Math.min(max, v);
    return v;
  }

  // Used by UI handlers to guarantee exact +/-1 with floor at 0
  function nextQty(currentQty, delta, opts) {
    var min = (opts && typeof opts.min === 'number') ? opts.min : 0;
    var max = (opts && typeof opts.max === 'number') ? opts.max : undefined;
    return clampInt((clampInt(currentQty, min, max) + delta), min, max);
  }

  /**
   * computeExtrasPricing({ passengerCount, beverages[], snacks[] }) -> { lineItems, totals }
   *
   * Deterministic free drink credit allocation:
   * - free drink credits = passengerCount
   * - allocated in the order of `beverages[]`
   *
   * Snacks:
   * - gum is free up to passengerCount (hard cap applied here; paid gum is not allowed)
   * - all other snacks are always paid (qty * unitPrice)
   */
  function computeExtrasPricing(input) {
    var passengerCount = clampInt(input && input.passengerCount, 1, 99);
    var beverages = Array.isArray(input && input.beverages) ? input.beverages : [];
    var snacks = Array.isArray(input && input.snacks) ? input.snacks : [];

    var lineItems = [];
    var drinkCreditsRemaining = passengerCount;

    // Beverages: apply pooled credits across all drinks.
    beverages.forEach(function (b) {
      var qty = clampInt(b && b.qty, 0, 999);
      var unitPrice = Number(b && b.unitPrice) || 0;
      var freeQty = Math.min(qty, drinkCreditsRemaining);
      var paidQty = Math.max(0, qty - freeQty);
      drinkCreditsRemaining -= freeQty;

      var lineTotal = paidQty * unitPrice;
      lineItems.push({
        id: b && b.id,
        category: 'beverage',
        name: (b && b.name) || '',
        qty: qty,
        freeQty: freeQty,
        paidQty: paidQty,
        unitPrice: unitPrice,
        lineTotal: lineTotal,
        isFreeLabel: lineTotal <= 0
      });
    });

    // Snacks: gum free up to passengerCount (cap), other snacks always paid.
    snacks.forEach(function (s) {
      var qty = clampInt(s && s.qty, 0, 999);
      var unitPrice = Number(s && s.unitPrice) || 0;
      var isGum = !!(s && s.isGum);

      if (isGum) {
        // Hard cap: gum cannot exceed passengerCount
        qty = Math.min(qty, passengerCount);
        lineItems.push({
          id: s && s.id,
          category: 'snack',
          name: (s && s.name) || '',
          qty: qty,
          freeQty: qty,
          paidQty: 0,
          unitPrice: unitPrice,
          lineTotal: 0,
          isFreeLabel: true
        });
        return;
      }

      var lineTotal = qty * unitPrice;
      lineItems.push({
        id: s && s.id,
        category: 'snack',
        name: (s && s.name) || '',
        qty: qty,
        freeQty: 0,
        paidQty: qty,
        unitPrice: unitPrice,
        lineTotal: lineTotal,
        isFreeLabel: lineTotal <= 0
      });
    });

    var paidDrinksTotal = 0;
    var paidSnacksTotal = 0;
    lineItems.forEach(function (li) {
      if (li.category === 'beverage') paidDrinksTotal += li.lineTotal;
      if (li.category === 'snack') paidSnacksTotal += li.lineTotal;
    });

    return {
      lineItems: lineItems,
      totals: {
        passengerCount: passengerCount,
        paidDrinksTotal: paidDrinksTotal,
        paidSnacksTotal: paidSnacksTotal,
        extrasTotal: paidDrinksTotal + paidSnacksTotal
      }
    };
  }

  root.UrbixxComputeExtrasPricing = computeExtrasPricing;
  root.UrbixxNextQty = nextQty;
})(typeof window !== 'undefined' ? window : globalThis);


